window.Products.Clothing.BabyLeggings6months = function() {};

window.Products.Clothing.BabyLeggings6months.inherits(window.Products.Clothing.BabyLeggings);
window.Products.Clothing.BabyLeggings6months.has_3d = true;
window.Products.Clothing.BabyLeggings6months.id = '27-6months';
window.Products.Clothing.BabyLeggings6months.saveId = 27;
window.Products.Clothing.BabyLeggings6months.slug = 'baby-leggings-6months';
window.Products.Clothing.BabyLeggings6months.dpi = 150;